import { Ref } from 'react'
import { IMaskMixin } from 'react-imask'

import AppInput from './AppInput'

const AppInputMasked = IMaskMixin(({ inputRef, ...props }) => {
  return <AppInput {...props} ref={inputRef as Ref<HTMLInputElement>} />
})

export default AppInputMasked
